import { jsx as _jsx } from "react/jsx-runtime";
import { StyledEngineProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ThemeProvider } from './themes/ThemeProvider';
var queryClient = new QueryClient();
var root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(QueryClientProvider, { client: queryClient, children: _jsx(ThemeProvider, { children: _jsx(StyledEngineProvider, { injectFirst: true, children: _jsx(App, {}) }) }) }));
